import React, { useEffect, useState } from 'react';
import { AssignmentStatus, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faTelegram, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { faBan, faBell, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleHalfStroke, faClock, faEnvelopeOpenText, faList, faPaperclip, faPhone, faRectangleXmark, faTasks, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, MenuProps, Tooltip } from 'antd';
import { faEnvelope, faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { setPopUpTreatmentModel, setTreatmentId, setTypeTreatmentsAction } from '../app-context/tasksSlice';
import { redirect, useNavigate } from 'react-router-dom';
import { LeadsModel } from '../models/LeadsModel';
import { get, set } from 'lodash';
import { RootState } from '../app-context/store';
import { setLeadIdForTreatment, setRedirectToLeads } from '../app-context/leadsSlice';

type Props = {
    treatmentDetails: any;
    config: any;
    actions: any;
    fromLeadTableType?: boolean;
    fromClientTableType?: boolean;
    fromSue?: boolean;
    fromClientCard?: boolean;
    fromSign?: boolean;
};

const ClientTreatmentAssignment = (props: Props) => {

    const leadModel: LeadsModel = new LeadsModel();
    const [treatmentItem, setTreatmentItem] = useState<TreatmentModel>(props.treatmentDetails);
    const [clientItems, setClientItems] = useState<MenuProps['items']>([]);
    const [apiUrl, setApiUrl] = useState<string>('');
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns);
    const [statusColor, setStatusColor] = useState<string>('grey');
    const [statusLabel, setStatusLabel] = useState<string>('');
    const [showStatus, setShowStatus] = useState<boolean>(true);
    const [treatmentNote, setTreatmentNote] = useState<string>('');
    const [statusIcon, setStatusIcon] = useState<IconDefinition>(faClock);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [createdBy, setCreatedBy] = useState<any>({});
    const [userData, setUserData] = useState<any>({});
    const [leadInfo, setLeadInfo] = useState<any>({});
    const [fromClient, setFromClient] = useState<boolean>(props.fromClientTableType || false);
    const [fromLeads, setFromLeads] = useState<boolean>(props.fromLeadTableType || false);

    const [serverPath, setServerPath] = useState<string>('');

    const phoneNumberOfLead = useSelector((state: RootState) => state.leads.phoneNumberOfLead);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isValidUrl = (input: string): boolean => {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/i;
        return urlPattern.test(input);
    }

    const isHTML = (str: string): boolean => {
        const htmlPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlPattern.test(str);
    }

    const downloadDocument = (docUrl: string | undefined) => {
        if (apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl);
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target = '_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const emptyFunc = () => { }

    const onMenuClicked = (type: string) => {
        if (type != 'sendEmail' && type != 'sendWhatsApp') {

            switch (type) {
                case 'edit':
                    console.log('editTask');
                    if (props.actions.edit) {
                        if (treatmentItem.treatmentType == 4) {
                            props.actions.editDoc(treatmentItem.id);
                            dispatch(setTypeTreatmentsAction("edit"));
                            if (treatmentItem.id) {
                                dispatch(setTreatmentId(treatmentItem.id));
                            }
                            if (treatmentItem.leadRelatedId && treatmentItem.leadRelatedId.length > 0) {
                                dispatch(setLeadIdForTreatment(treatmentItem.leadRelatedId));
                            }
                        } else {
                            props.actions.edit(treatmentItem.id);
                            if (treatmentItem.leadRelatedId && treatmentItem.leadRelatedId.length > 0) {
                                dispatch(setLeadIdForTreatment(treatmentItem.leadRelatedId));
                            }
                        }
                        // dispatch(setTypeTreatmentsAction('edit'));

                    }
                    break;

                case 'reference':
                    if (props.actions.reference) {
                        props.actions.reference(treatmentItem.id);
                    }
                    break;

                case 'changeHandler':
                    if (props.actions.changeHandler) {
                        props.actions.changeHandler(treatmentItem.id);
                    }
                    break;
                case 'sendEmail':
                    if (props.actions.sendEmail) {
                        props.actions.sendEmail(treatmentItem.id);
                    }
                    break;
                case 'sendWhatsApp':
                    if (props.actions.sendWhatsApp) {
                        props.actions.sendWhatsApp(treatmentItem.id);
                    }
                    break;
                case 'print':
                    if (props.actions.print) {
                        props.actions.print(treatmentItem.id);
                    }
                    break;
                case 'delete':
                    if (props.actions.delete) {
                        props.actions.delete(treatmentItem.id);
                    }
                    break;
                case 'setPerformedStatus': {
                    if (props.actions.setStatus) {
                        props.actions.setStatus(treatmentItem.id, 'd47d390a-5be2-42b4-b79f-13e6a4b14cef');
                    }
                    break;
                }

                case 'setNotYetPerformedStatus': {
                    if (props.actions.setStatus) {
                        props.actions.setStatus(treatmentItem.id, '45cb3c16-f64f-40d5-9863-42a742ce4624');
                    }
                    break;
                }
                case 'redirtToClient':
                    if (props.actions.redirectToClient) {
                        if (treatmentItem.leadRelatedId && treatmentItem.leadRelated) {
                            const lastLeadsFilter = localStorage.getItem('lastLeadsFilter');
                            if (lastLeadsFilter) {
                                const lastFilter = JSON.parse(lastLeadsFilter);
                                console.log('lastFilter', lastFilter);
                                lastFilter.searchText = treatmentItem.leadRelated ? treatmentItem.leadRelated.phoneNumber1 : '';
                                localStorage.setItem('lastLeadsFilter', JSON.stringify(lastFilter));
                                dispatch(setRedirectToLeads(true));
                                navigate('/leads');
                                // props.actions.redirectToClient(treatmentItem.customer, lastFilter);
                            }
                        }

                        if (treatmentItem.customer) {
                            props.actions.redirectToClient(treatmentItem.customer);
                        }
                    }
                    break;

                case 'redirectToWhatsApp':
                    if (treatmentItem.leadRelatedId && treatmentItem.leadRelated) {
                        localStorage.setItem('selectedWhatsAppLead', treatmentItem.leadRelated.phoneNumber1);
                        navigate('/Whatsapp');
                    } else if (phoneNumberOfLead && phoneNumberOfLead.length > 0) {
                        localStorage.setItem('selectedWhatsAppLead', phoneNumberOfLead);
                        navigate('/Whatsapp');
                    } else if (treatmentItem && treatmentItem.customerId) {
                        localStorage.setItem('selectedWhatsApCustomer', treatmentItem.customerId || '');
                        navigate('/Whatsapp');
                    }

                    break;

                case 'editCalling':
                    if (props.actions.editCalling) {
                        props.actions.editCalling(treatmentItem.id);
                    }


                    break;
                default:
                    break;
            }
        }
    }

    const onShowDocument = () => {
        if (props.actions && props.actions.onShowDocument && treatmentItem.treatmentDocuments && treatmentItem.treatmentDocuments.length > 0) {
            console.log('onShowDocument', apiUrl + treatmentItem.treatmentDocuments[0].filePath);
            props.actions.onShowDocument(treatmentItem.treatmentDocuments)
        }
    }

    useEffect(() => {
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
    }, [props])



    useEffect(() => {
        getPersonalDetailsTreatments();

        const treatmentItem = props.treatmentDetails;
        if (!treatmentItem.assignmentStatus) {
            if (treatmentItem.treatmentType !== 2) {
                // treatmentItem.assignmentStatus = AssignmentStatus.NotYetPerformed;
                setStatusColor('green');
                setStatusLabel('לא בוצע');
            } else if (treatmentItem.treatmentType == 2 && treatmentItem.topic == "תחילת שיחה עם לקוח") {
                treatmentItem.assignmentStatus = AssignmentStatus.NotYetPerformed;
                setStatusColor('green');
                setStatusLabel('לא בוצע');
            } else if (treatmentItem.treatmentType == 2 && treatmentItem.topic !== "תחילת שיחה עם לקוח") {
                setStatusColor('');
                setStatusLabel('');
            }
        } else {
            const assignmentStatusId = treatmentItem.assignmentStatus.id || treatmentItem.assignmentStatus.Id;
            const assignmentStatusName: string = treatmentItem.assignmentStatus.name || treatmentItem.assignmentStatus.Name;
            setStatusLabel(assignmentStatusName);
            switch (assignmentStatusId) {
                case 'd47d390a-5be2-42b4-b79f-13e6a4b14cef': //AssignmentStatus.Performed:
                    setStatusColor('limegreen');
                    setStatusIcon(faCircleCheck)
                    break;
                    // case AssignmentStatus.NotifiedOnly: 
                    //     setShowStatus(false)
                    break;
                case '45cb3c16-f64f-40d5-9863-42a742ce4624': //(AssignmentStatus as any).NotYetPerformed:
                    if (moment(treatmentItem.endDate).format('YYYY-MM-DD') != '0001-01-01' && moment(treatmentItem.endDate).isBefore(moment())) {
                        setStatusColor('red');
                        // setStatusLabel('פיגור');
                    } else {
                        setStatusColor('green');
                    }
                    // setStatusLabel('טרם בוצעה');
                    break;
                case '773a54ec-0032-4485-afe5-6c8c8266dacd':
                    setStatusColor('grey');
                    break;
                // case '61b57b27-3e29-4fe0-a8cd-ecba91b99906': // AssignmentStatus.Pending:
                //     setStatusColor('red');
                //     break;

                default:
                    if (moment(treatmentItem.endDate).format('YYYY-MM-DD') != '0001-01-01' && moment(treatmentItem.endDate).isBefore(moment())) {
                        setStatusColor('red');
                        // setStatusLabel('פיגור');
                    } else {
                        setStatusColor('green');
                    }
                    break;
            }
        } if (treatmentItem.treatmentType == 2 && treatmentItem.location && treatmentItem.location.length > 0
            && treatmentItem.location.indexOf('http://') > -1) {
            setTreatmentNote(treatmentItem.location);
        } else
            if (treatmentItem.emailBody !== '') {
                // const activitiesLength = treatmentItem.treatmentActivities.length
                const notesText = treatmentItem.emailBody ? treatmentItem.emailBody.replace(/(<([^>]+)>)/gi, '').replace('&nbsp;', '') : '';

                setTreatmentNote(notesText);
            }
        if (treatmentItem && treatmentItem.customerId) {


            // if (treatmentItem.emailBody) {
            //     setTreatmentNote(treatmentItem.emailBody);
            // }


        } else {
            // if (treatmentItem.note) {
            //     setTreatmentNote(treatmentItem.note);
            // }
        }
        setTreatmentItem(treatmentItem);

        let isAdmin = false;
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            isAdmin = loggedUser.role == 0;
            setIsAdmin(isAdmin);
            // setCurrentUser(loggedUser);
        }

        let userList = localStorage.getItem('usersList');
        let users: any[] = [];
        if (userList) {
            users = JSON.parse(userList);
            setUserData(users.find((user: any) => user.id == treatmentItem.belongsToId));
        }

        var menuOptions: MenuProps['items'] = [
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('edit') }}
                    >
                        עדכן
                    </li>,
                key: '1edit',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('reference') }}
                    >
                        שייך ל...
                    </li>,
                key: 'reference',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('changeHandler') }}
                    >
                        שנה מטפל
                    </li>,
                key: 'changeHandler',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('setPerformedStatus') }}
                    >
                        סמן כבוצע
                    </li>,
                key: 'setPerformedStatus',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('setNotYetPerformedStatus') }}
                    >
                        סמן כלא בוצע
                    </li>,
                key: 'setNotYetPerformedStatus',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('sendEmail') }}
                    >
                        שלח אימייל
                    </li>,
                key: 'sendEmail',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('sendWhatsApp') }}
                    >
                        שלח וואצפ
                    </li>,
                key: 'sendWhatsApp',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('print') }}
                    >
                        הדפס
                    </li>,
                key: 'print',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('redirtToClient') }}
                    >
                        {(treatmentItem.leadRelatedId && treatmentItem.leadRelatedId.length > 0) ||
                            (treatmentItem.offerRelatedId && treatmentItem.offerRelatedId.length > 0) ? 'מעבר לליד' : 'עבור לתיק לקוח'
                        }
                    </li>,
                key: 'redirectToClient',
            }


        ];
        if (isAdmin) {
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('delete') }}
                    >
                        מחק
                    </li>,
                key: 'delete',
            })
        }

        if (treatmentItem.sueRelatedId && treatmentItem.sueRelatedId.length > 0 && treatmentItem.sueRelated) {
            menuOptions = [...menuOptions.filter((item: any) => item.key !== 'reference')];
        }

        // from client card - remove reference option
        if(props.fromClientCard === true || (props.fromSign && props.fromSign == true)){
            // remove reference from menuOptions
            menuOptions = [...menuOptions.filter((item: any) => item.key !== 'reference')];
        }


        if (treatmentItem.treatmentType == 2) {
            //remove item from menuOptions
            var options = menuOptions.filter((item: any) => item.key !== 'sendWhatsApp' && item.key !== 'sendEmail' && item.key !== 'delete' && item.key !== '1edit' && item.key !== 'print'
                && item.key !== 'changeHandler' && item.key !== 'redirectToClient');
            options.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('redirectToWhatsApp') }}
                    >
                        עבור להתכתבות
                    </li>,
                key: 'redirectToWhatsApp',
            });

            if (fromLeads === true) {
                options = [...options.filter((item: any) => item.key !== 'redirectToClient')];
            }

            setClientItems(options);
        } else if (treatmentItem.treatmentType != 0) {
            if (fromLeads === true) {
                let optionInLead = menuOptions.filter((item: any) => item.key !== 'redirectToClient');
                setClientItems(optionInLead);
            } else {
                setClientItems(menuOptions);
            }
        } else if (treatmentItem.treatmentType == 0) {
            console.log('useEffect-treatment 0')
            setClientItems([
                {
                    label:
                        <li className="pointer rtl"
                            onClick={() => { onMenuClicked('editCalling') }}
                        >
                            ערוך סיכום שיחה
                        </li>,
                    key: 'editCalling',
                }
            ]);
        }




        const callServerPath = localStorage.getItem('callDownloadPath');
        if (serverPath == '' && callServerPath) {
            setServerPath(callServerPath);
        }

    }, [])

    const getPersonalDetailsTreatments = async () => {
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            const lead = await leadModel.getLeadForUpsert(treatmentItem.offerRelated.leadId);
            if (lead) {
                // return lead.firstName + ' ' + lead.lastName;
                setLeadInfo(lead);
            }
        }
    }

    const getCompanyName = (companyId: string) => {
        let companyList = localStorage.getItem('companyList');
        let companies: any[] = [];
        if (companyList) {
            companies = JSON.parse(companyList);
            let company = companies.find((company: any) => company.id == companyId);
            return company.name;
        }
        return '';
    }


    const getIcon = () => {
        switch (treatmentItem.treatmentType) {

            case TreatmentType._3:
                return faEnvelope;
            // case TreatmentType.Meeting:
            //     return faHandshake;
            // case TreatmentType.Fax:
            //     return faFax;
            // case TreatmentType.SMS:
            //     return faSms;
            // case TreatmentType.Documentation:
            //     return faFileAlt;
            case TreatmentType._2:
                return faWhatsapp;
            case TreatmentType._1:
                return faTasks;
            case TreatmentType._0:
                return faPhone;
            // case TreatmentType.Summary:
            //     return faClipboardList;
            // case TreatmentType.OutgoingMail:
            //     return faMailBulk;
            case TreatmentType._6:
                return faEnvelopeOpenText;

            case TreatmentType._4:
                return faFileAlt;

            default:
                return faFileAlt;
        }
    }

    const getInsuranceCompanieById = (companyId: string) => {
        let insuranceCompaniesList = localStorage.getItem('insuranceCompanies');
        let insuranceCompanies: any[] = [];
        if (insuranceCompaniesList) {
            insuranceCompanies = JSON.parse(insuranceCompaniesList);
            let company = insuranceCompanies.find((company: any) => company.value == companyId);
            return company.label;
        }
        return '';
    }

    const getRefferenceInfo = () => {

        if (treatmentItem.policyRelatedId && treatmentItem.policyRelated) {
            let referrenceText = '';
            if (treatmentItem.policyRelated.policyNumber) {
                referrenceText = `פוליסה מספר: ${treatmentItem.policyRelated.policyNumber},`
            }
            if (treatmentItem.policyRelated && treatmentItem.policyRelated.vehicle) {
                referrenceText += ` מס' רכב: ${treatmentItem.policyRelated.vehicle.licenseNumber ? treatmentItem.policyRelated.vehicle.licenseNumber :
                    treatmentItem.policyRelated.vehicle.modelCode},`
            }
            if (treatmentItem.policyRelated.insuranceCompanyId) {
                referrenceText += ` חברה: ${getInsuranceCompanieById(treatmentItem.policyRelated.insuranceCompanyId)}`
            }
            return referrenceText;
        }
        else if (treatmentItem.sueRelatedId && treatmentItem.sueRelated) {
            let referrenceText = '';
            if (treatmentItem.sueRelated.sueNumber) {
                referrenceText = `תביעה מספר: ${treatmentItem.sueRelated.sueNumber},`;
            }
            if (treatmentItem.sueRelated.driver && treatmentItem.sueRelated.driver.vehicle && treatmentItem.sueRelated.driver.vehicle.licenseNumber) {
                referrenceText += ` מס' רכב: ${treatmentItem.sueRelated.driver.vehicle.licenseNumber},`
            }
            if (treatmentItem.sueRelated.insuranceCompanyId) {
                referrenceText += ` חברה: ${getInsuranceCompanieById(treatmentItem.sueRelated.insuranceCompanyId)}`
            }
            return referrenceText;
        }
        else if (treatmentItem.offerRelatedId) {
            if (treatmentItem.offerRelated) {
                let referrenceText = '';
                if (treatmentItem.offerRelated.offerIdentity) {
                    referrenceText = `הצעה מספר: ${treatmentItem.offerRelated.offerIdentity},`
                }
                if (treatmentItem.offerRelated.vehicle && treatmentItem.offerRelated.vehicle.licenseNumber) {
                    referrenceText += ` מס' רכב: ${treatmentItem.offerRelated.vehicle.licenseNumber},`
                }
                return referrenceText;
            }
        }
        else if (treatmentItem.leadRelatedId) {
            if (treatmentItem.leadRelated) {
                if (treatmentItem.leadRelated.identifier && treatmentItem.leadRelated.customer && treatmentItem.leadRelated.customer.vehicles && treatmentItem.leadRelated.customer.vehicles.length > 0) {
                    return `ליד מספר: ${treatmentItem.leadRelated.identifier}, מס' רכב: ${treatmentItem.leadRelated.customer.vehicles[0].licenseNumber},}`;
                }
            }
        }
        return '';

    }

    const getTreatmentType = (treatmentType: any) => {
        if (treatmentType == '1') {
            return 'משימה';
        } else if (treatmentType == '3') {
            return 'אימייל';
        } else if (treatmentType == '4') {
            return 'תיעוד';
        } else {
            return '';
        }
    }

    const getAgent = (agentId: string) => {
        let agentList = localStorage.getItem('agents');
        let agents: any[] = [];
        if (agentList) {
            agents = JSON.parse(agentList);
            let agent = agents.find((agent: any) => agent.id == agentId);
            return agent.name;
        }
        return '';
    }

    const getFullName = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.fullName) {
            return treatmentItem.customer.fullName;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.firstName || treatmentItem.leadRelated.lastName ?
                treatmentItem.leadRelated.firstName + ' ' + treatmentItem.leadRelated.lastName : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.firstName || leadInfo.lastName ? leadInfo.firstName + ' ' + leadInfo.lastName : '';
        }
        return ''
    }


    const getIdentifier = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.identifier) {
            return treatmentItem.customer.identifier;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.identifier ? ` ${treatmentItem.leadRelated.identifier}` : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.identifier ? ` ${leadInfo.identifier}` : '';
        }
        return ''
    }

    const getCreatedByFullName = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.updatedBy) {
            return treatmentItem.updatedBy.fullName;
        }
        if (treatmentItem.updatedById) {
            let userList = localStorage.getItem('usersList');
            let users: any[] = [];
            if (userList) {
                users = JSON.parse(userList);
                let user = users.find((user: any) => user.id == treatmentItem.updatedById);
                return user.fullName;
            }
        }
    }

    const getPhoneNumber = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.customer && treatmentItem.customer.customerContactDetails && treatmentItem.customer.customerContactDetails.length > 0
            && treatmentItem.customer.customerContactDetails[0].number) {
            return treatmentItem.customer.customerContactDetails[0].number;
        }
        if (treatmentItem.leadRelated) {
            return treatmentItem.leadRelated.phoneNumber1 ? ` ${treatmentItem.leadRelated.phoneNumber1}` : '';
        }
        if (treatmentItem.offerRelated && treatmentItem.offerRelated.leadId) {
            return leadInfo.phoneNumber1 ? ` ${leadInfo.phoneNumber1}` : '';
        }
        return ''
    }

    const getUserDetails = (treatmentItem: TreatmentModel) => {
        if (treatmentItem.user && treatmentItem.user.fullName) {
            return treatmentItem.user.fullName;
        }
        if (treatmentItem.userId) {
            let userList = localStorage.getItem('usersList');
            let users: any[] = [];
            if (userList) {
                users = JSON.parse(userList);
                let user = users.find((user: any) => user.id == treatmentItem.userId);
                if (user) {
                    return user.fullName;
                }
            }
        } else if (treatmentItem.updatedBy) {
            return treatmentItem.updatedBy.fullName;
        } else if (treatmentItem.updatedById) {
            let userList = localStorage.getItem('usersList');
            let users: any[] = [];
            if (userList) {
                users = JSON.parse(userList);
                let user = users.find((user: any) => user.id == treatmentItem.updatedById);
                if (user) {
                    return user.fullName;
                }
            }
        }
        return '';
    }


    const getDownloadLink = (filePath: any): string => {
        if (filePath && filePath.length > 0 && filePath !== '/') {
            return `${apiUrl}${serverPath}${encodeURI(filePath)}`;
        }
        return '';
    };

    const handleDownloadClick = (filePath: string) => {
        const url = getDownloadLink(filePath);
        if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', ''); // this hints to the browser to download
            link.setAttribute('target', '_blank'); // optional: open in new tab if needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.warn('Invalid file path for download.');
        }
    };

    const hasPermission = (): boolean => {
        const savedLoggedUser = localStorage.getItem('loggedUser');
        if (savedLoggedUser) {
            const loggedUser = JSON.parse(savedLoggedUser);
            return loggedUser.role === 0 || loggedUser.role === 7 || loggedUser.role === 10; // Admin or Manager
        }
        return false;
    }

    return (
        <Dropdown menu={{ items: clientItems }} trigger={!props.fromSue || treatmentItem.treatmentType == 1 ? ['contextMenu'] : []}>
            <div className={`data-card client-details-row client-item`} onDoubleClick={() => {
                if (treatmentItem.treatmentType != 0 && !props.fromSue) { onMenuClicked('edit') }
            }}>
                <div className={`flex-centered ${(treatmentItem.seen || treatmentItem.treatmentType == 0) ? '' : 'unseen'}`}>
                    <div className="row-cell icon-cell">
                        {/* <div>
                            {
                                treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && <FontAwesomeIcon icon={faBell} title={`${treatmentItem.alertDate}`} />
                            }
                        </div> */}
                        {/* <div style={{ marginRight: '5px' }}> */}
                        {
                            <FontAwesomeIcon icon={getIcon()} title={`${getTreatmentType(treatmentItem.treatmentType)}`}
                                size='lg'
                            />
                        }
                        {/* </div> */}

                    </div>
                    <div
                        // className={`row-cell status ${statusColor}`} 
                        style={{
                            color: `${statusColor}`,
                            fontSize: 'medium',
                            width: '130px',
                            textAlign: 'right',
                            direction: 'rtl',
                            display: `flex`,
                        }}>
                        {showStatus && statusLabel.length > 0 && treatmentItem.treatmentType != 0 &&
                            <>
                                <div className='status-icon'>
                                    <FontAwesomeIcon icon={statusIcon} />
                                </div>
                                <div>
                                    {statusLabel}
                                </div>
                            </>
                        }
                    </div>
                    <div className="row-cell client-name"
                        style={{ display: (fromLeads === true || props.fromClientCard  === true || props.fromSue ) ? 'none' : '' }}>
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }} >
                            {getFullName(treatmentItem)}
                        </div>
                    </div>
                    <div className={`row-cell client-id`}
                        style={{ display: (fromLeads === true || props.fromClientCard  === true || props.fromSue)  ? 'none' : '' }}>
                        <div className="description cell-value">
                            {getIdentifier(treatmentItem)}
                        </div>
                    </div>

                    <div className={`row-cell client-id`}
                        style={{ display: (fromLeads === true || props.fromClientCard  === true|| props.fromSue)  ? 'none' : '' }}>
                        <div className="description cell-value">
                            {getPhoneNumber(treatmentItem)}
                        </div>
                    </div>

                    <div className="row-cell created">
                        <div className="description cell-value">
                            {moment(treatmentItem.createdDate).format('DD-MM-YYYY')}
                        </div>
                        <div className="description">
                            {(moment(treatmentItem.createdDate)).format('HH:mm')}
                        </div>
                    </div>


                    <div className={`row-cell eventDate ${!additionalColumns || additionalColumns.eventDate.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.treatmentType == 4 && treatmentItem.eventDate && moment(treatmentItem.eventDate).isValid() ? moment(treatmentItem.eventDate).format('DD-MM-YYYY') : ''}
                        </div>
                        <div className="description">
                            {treatmentItem.treatmentType == 4 && treatmentItem.eventDate && (moment(treatmentItem.eventDate)).format('HH:mm')}
                        </div>
                    </div>

                    <div className="row-cell alertDate"
                    style={{ display: props.fromSign ? 'none' : '' }}>
                        <div className="description cell-value">
                            {treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() ? moment(treatmentItem.alertDate).format('DD-MM-YYYY') : ''}
                            {
                                treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && <FontAwesomeIcon icon={faBell} title={`${treatmentItem.alertDate}`} style={{ marginRight: 5 }} />
                            }
                        </div>
                        <div className="description">
                            {treatmentItem.alertDate && moment(treatmentItem.alertDate).isValid() && (moment(treatmentItem.alertDate)).format('HH:mm')}
                        </div>
                    </div>
                    <div className={'row-cell alertDate endOfGoal'}>
                        <div className="description cell-value">
                            {treatmentItem.treatmentType != 0 && treatmentItem.endDate && moment(treatmentItem.endDate).format('DD-MM-YYYY') !== '01-01-0001' ?
                                (<>
                                    {moment(treatmentItem.endDate).format('DD-MM-YYYY')}
                                </>) : (<></>)}
                        </div>
                        <div className="description">
                            {treatmentItem.treatmentType != 0 && treatmentItem.endDate && moment(treatmentItem.endDate).format('DD-MM-YYYY') !== '01-01-0001' && (moment(treatmentItem.endDate)).format('HH:mm')}
                        </div>
                    </div>
                    <div className="row-cell topic" >
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }}>
                            {treatmentItem.topic ? (<>
                                {treatmentItem.topic}</>) : (<>
                                    ללא נושא
                                </>)}
                            {/* <span>&nbsp;</span> */}
                            {/* <FontAwesomeIcon icon={faPhone} /> */}
                        </div>
                    </div>
                    <div className="row-cell handler">
                        <div className="description cell-value">
                            {treatmentItem.belongsToId ?
                                (<>
                                    {treatmentItem.belongsToId && userData && userData.fullName ? userData.fullName : ' '}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className="row-cell treatment-note">
                        <div className="description cell-value">
                            {treatmentNote ? (<>
                                <Tooltip title={() => {
                                    return (isValidUrl(treatmentNote) ?
                                        <a target="_blank" href={treatmentNote}>{treatmentNote}</a>
                                        :
                                        treatmentItem.emailBody && (
                                            isHTML(treatmentItem.emailBody) ? (
                                                <div dangerouslySetInnerHTML={{ __html: treatmentItem.emailBody }} />
                                            ) :
                                                <>
                                                    {treatmentItem.emailBody}
                                                </>
                                        )
                                    )
                                }} color={'#027BFD'} placement="right">
                                    {/* {treatmentNote} */}
                                    <div className="icon comment"></div>
                                    {/* comment */}
                                </Tooltip>


                            </>) : (<>

                            </>)}
                        </div>
                    </div>
                    <div className="row-cell creator">
                        <div className="description cell-value">
                            {getUserDetails(treatmentItem)}
                        </div>
                    </div>
                    <div className="row-cell file icon-file-cell">
                        <div className="description cell-value">
                            {treatmentItem.treatmentType != 0 && treatmentItem.treatmentDocuments && treatmentItem.treatmentDocuments.length > 0 ?
                                (<>
                                    <FontAwesomeIcon className='pointer' icon={faPaperclip} onClick={onShowDocument} />
                                </>) : treatmentItem.treatmentType == 0 && treatmentItem.filePath && hasPermission() ?
                                    <FontAwesomeIcon className='pointer' icon={faPaperclip} onClick={() => handleDownloadClick(treatmentItem.filePath as string)} />
                                    : (<></>)}
                        </div>
                    </div>
                    {/* <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.portfolio.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            
                        </div>
                    </div> */}
                    <div className={`row-cell short program-name ${(!additionalColumns || additionalColumns.agent.hidden)|| props.fromSign ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.agentId ?
                                (<>
                                    {getAgent(treatmentItem.agentId)}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.company.hidden ? 'hide' : ''}`}
                    >
                        <div className="description cell-value">
                            {treatmentItem.company ?
                                (<>
                                    {treatmentItem.companyId ? getCompanyName(treatmentItem.companyId) : ''}
                                    {treatmentItem.company.name}
                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short client-name ${!additionalColumns || additionalColumns.modifiedBy.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.updatedBy || treatmentItem.updatedById ?
                                (<>
                                    {getCreatedByFullName(treatmentItem)}
                                    {/* treatmentItem.updatedBy.fullName */}

                                </>) : (<></>)}
                        </div>
                    </div>
                    <div className={`row-cell short changeDate ${!additionalColumns || additionalColumns.changeDate.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value">
                            {treatmentItem.updatedDate ?
                                (<>
                                    {moment(treatmentItem.updatedDate).format('DD-MM-YYYY')}
                                </>) : (<></>)}
                        </div>
                        <div className="description">
                            {treatmentItem.updatedDate && (moment(treatmentItem.updatedDate)).format('HH:mm')}
                        </div>
                    </div>
                    {!fromLeads &&
                        <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.groups.hidden ? 'hide' : ''}`}
                        >
                            <div className="description cell-value">

                            </div>
                        </div>
                    }
                    {!fromLeads &&
                        <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.employer.hidden ? 'hide' : ''}`}
                        >
                            <div className="description cell-value">

                            </div>
                        </div>
                    }
                    <div className={`row-cell short program-name ${!additionalColumns || additionalColumns.referrence.hidden ? 'hide' : ''}`}>
                        <div className="description cell-value" style={{ whiteSpace: 'inherit' }}>
                            {getRefferenceInfo()}
                            {/* {treatmentItem && treatmentItem.policyRelatedId ?'פוליסה' : treatmentItem.sueRelatedId ? 'תביעה' : treatmentItem.leadRelatedId ? 'ליד' : ''} */}
                        </div>
                    </div>


                    <div className={`row-cell actions ${props.fromSue && treatmentItem.treatmentType != 1 ? 'hide' : ''}`}>
                        {<Dropdown menu={{ items: clientItems }} trigger={['click']}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>}
                    </div>
                </div>
            </div>
        </Dropdown>
    )
}

export default ClientTreatmentAssignment;